enum TenantEditMode {
  CREATE,
  DUPLICATE,
  EDIT,
}

export default TenantEditMode;